import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { ROUTES } from '../constants/routes';
import { userHasSubApp } from '../utils/rbac';

function SubAppRoute({ appKey, children }) {
  const { user, token } = useContext(AuthContext);
  if (!user || !token) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  if (!userHasSubApp(user, appKey)) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  return children;
}

export default SubAppRoute;
